export enum CalendarViewType {
  Month = 'dayGridMonth',
  Year = 'multiMonthYear',
}
